<template>
  <Container>
    <Title>{{ filters }} and {{ region }} at a Glance</Title>
    <Table vif="tables" v-for="(table, key) in tables" :key="key">
      <TableContent>
        <Header>{{ table.title }}</Header>
        <Cells v-for="(cell, cellKey) in table.cells" :key="cellKey">
          <CellLabel>{{ cell.label }}</CellLabel>
          <CellValue>
            {{ cell.value }}<Unit>{{ cell.unit }}</Unit>
          </CellValue>
        </Cells>
      </TableContent>
    </Table>
  </Container>
</template>

<script>
import { find, isNil, last, pathOr, filter } from 'ramda';
import { orderOfMagnitudeObject } from '@shared/utils/formatNumbers';
import {
  Container,
  Title,
  Table,
  TableContent,
  Header,
  Cells,
  CellLabel,
  CellValue,
  Unit,
} from './ataGlanceTable.styles';
import { CATEGORY, CATEGORIES_LIST, ITEMS_BY_CATEGORIES } from './ataGlanceTable.constants';
import { GET_SELECTED_FILTERS, GET_SELECTED_SUBTOPIC } from '@/modules/regions/regions.getters';
import { PREFIX as REGIONS_STORE } from '../../../modules/regions';
import { mapGetters } from 'vuex';
import { getRegionField, parseNumber } from '../../utils/helpers';

const NO_DATA = 'No Data';

export default {
  components: {
    Container,
    Title,
    Table,
    TableContent,
    Header,
    Cells,
    CellLabel,
    CellValue,
    Unit,
  },
  props: {
    dataSource: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters(REGIONS_STORE, [GET_SELECTED_FILTERS, GET_SELECTED_SUBTOPIC]),

    region() {
      const selectedRegion = pathOr('', ['tags', 'regions', 0], this[GET_SELECTED_SUBTOPIC]);

      return selectedRegion.charAt(0).toUpperCase() + selectedRegion.slice(1);
    },
    filters() {
      const regionField = getRegionField(this[GET_SELECTED_SUBTOPIC]);
      const defaultValue = regionField === 'Country' ? 'Countries' : regionField + 's';

      return last(this[GET_SELECTED_FILTERS]) || `All ${defaultValue}`;
    },
    tables() {
      const filteredData = filter(item => item[CATEGORY] !== 'Category')(this.dataSource);
      const selectedData = find(item => item[CATEGORY] === this.filters)(filteredData);

      const getSumValue = label => {
        const values = filteredData.map(item => item[label]);
        const value = values.reduce((prev, next) => prev + parseNumber(next), 0);

        return values ? orderOfMagnitudeObject(value, 1) : { value: NO_DATA };
      };

      const getValue = label => {
        const value = selectedData[label];

        if (isNil(value)) return {};

        const parsedNumber = parseNumber(value);

        return parsedNumber ? orderOfMagnitudeObject(parsedNumber, 1) : { value: NO_DATA };
      };

      const getContent = category =>
        ITEMS_BY_CATEGORIES[category].map(label => {
          if (isNil(selectedData)) {
            return {
              label: label,
              ...getSumValue(label),
            };
          } else {
            return {
              label: label,
              ...getValue(label),
            };
          }
        });

      return CATEGORIES_LIST.map(title => ({
        title,
        cells: getContent(title),
      }));
    },
  },
};
</script>
